module.exports = __webpack_public_path__ + "pSIbFAhLWaWz2Kf3O/agent-training-center_tips_for_success.png";